var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"node",class:_vm.nodeContainerClass,style:(_vm.nodeContainerStyle),on:{"click":_vm.clickNode,"mouseup":_vm.changeNodeSite}},[_c('el-image',{attrs:{"src":_vm.nodeContainerImg,"fit":"contain"}}),_c('div',{staticClass:"flow-node-drag auto-node-drge-hover"},[_c('span',{class:_vm.nodeIcoClass},[_vm._v(_vm._s(_vm.node.name))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }